// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__gDo_g","fade_in":"Main_fade_in__7F2f6"};